import React, { useState } from 'react';
import PageHeader from '../components/ui/PageHeader';
import { useAuthStore } from '../store/authStore';

export default function ProfilePage() {
  const { user, updateProfile, changePassword, isLoading } = useAuthStore();
  const [name, setName] = useState(user?.name || '');
  const [phone, setPhone] = useState(user?.phone || '');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const onSaveProfile = async (event) => {
    event.preventDefault();
    setMessage('');
    setError('');
    try {
      await updateProfile({ name: name.trim(), phone: phone.trim() });
      setMessage('Profile updated');
    } catch (err) {
      setError(err?.message || 'Failed to update profile');
    }
  };

  const onChangePassword = async (event) => {
    event.preventDefault();
    setMessage('');
    setError('');
    if (newPassword.length < 6) {
      setError('New password must be at least 6 characters');
      return;
    }
    try {
      await changePassword({ currentPassword, newPassword });
      setCurrentPassword('');
      setNewPassword('');
      setMessage('Password changed');
    } catch (err) {
      setError(err?.message || 'Failed to change password');
    }
  };

  return (
    <div className="min-h-full bg-[var(--background)]">
      <div className="max-w-xl mx-auto px-4 sm:px-6 pt-5 pb-10 sm:pt-8 space-y-6">
        <PageHeader
          title="Profile Settings"
          breadcrumbs={[
            { label: 'Patel Sales', href: '/' },
            { label: 'My Account', href: '/account' },
            { label: 'Profile' },
          ]}
        />

        {(message || error) && (
          <p className={`text-sm font-medium ${error ? 'text-red-600' : 'text-green-700'}`}>
            {error || message}
          </p>
        )}

        <form onSubmit={onSaveProfile} className="app-card p-5 space-y-4">
          <h2 className="text-base font-bold text-gray-900">Account details</h2>
          <label className="block text-sm font-medium text-gray-700">
            Name
            <input
              className="mt-1 w-full min-h-[44px] rounded-lg border border-gray-300 px-3"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              autoComplete="name"
            />
          </label>
          <label className="block text-sm font-medium text-gray-700">
            Email
            <input
              className="mt-1 w-full min-h-[44px] rounded-lg border border-gray-200 px-3 bg-gray-50"
              value={user?.email || ''}
              disabled
              readOnly
            />
          </label>
          <label className="block text-sm font-medium text-gray-700">
            Phone
            <input
              className="mt-1 w-full min-h-[44px] rounded-lg border border-gray-300 px-3"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              autoComplete="tel"
            />
          </label>
          <button
            type="submit"
            disabled={isLoading}
            className="btn-primary min-h-[44px] px-5 disabled:opacity-60"
          >
            Save profile
          </button>
        </form>

        <form onSubmit={onChangePassword} className="app-card p-5 space-y-4">
          <h2 className="text-base font-bold text-gray-900">Change password</h2>
          <label className="block text-sm font-medium text-gray-700">
            Current password
            <input
              type="password"
              className="mt-1 w-full min-h-[44px] rounded-lg border border-gray-300 px-3"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </label>
          <label className="block text-sm font-medium text-gray-700">
            New password
            <input
              type="password"
              className="mt-1 w-full min-h-[44px] rounded-lg border border-gray-300 px-3"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              autoComplete="new-password"
            />
          </label>
          <button
            type="submit"
            disabled={isLoading}
            className="btn-secondary min-h-[44px] px-5 disabled:opacity-60"
          >
            Update password
          </button>
        </form>
      </div>
    </div>
  );
}
